var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-echart-doughnut',_vm._b({staticClass:"w-100"},'app-echart-doughnut',{
    source: _vm.source,
    color: _vm.color,
    type: _vm.type,
    isNegative: _vm.isNegative
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }